import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';
export const findProductCoupon = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/coupon?` + params,
        method: 'GET'
    })
}

export const delCoupon = (ids) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon/${ids}`,
        method: 'DELETE'
    })
}

export const ableCoupon = (ids) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon/able/${ids}`,
        method: 'PUT'
    })
}
export const editCoupon = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon`,
        method: 'PUT',
        data: data
    })
}

export const findProductByClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sell/select?` + params,
        method: 'GET'
    })
}
export const addProductCoupon = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon`,
        method: 'POST',
        data: data
    })
}
export const findBrand = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand`,
        method: 'GET'
    })
}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}